module.exports = __webpack_public_path__ + "static/media/img_6.de173097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_6.jpg
// module id = 546
// module chunks = 0